import { OnInit } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { pairwise } from 'rxjs/operators';
var CompatNavigationComponent = /** @class */ (function () {
    function CompatNavigationComponent(auth) {
        this.auth = auth;
    }
    CompatNavigationComponent.prototype.ngOnInit = function () {
        // Note: this is a hack for allowing us to set transparent navigation
        // if the PHP template variable transparent_header is set to true.
        this.transparent =
            !!window.webappCompat &&
                !!window.webappCompat.navigation &&
                !!window.webappCompat.navigation.transparent;
        // HACK to force reload the current page when SwitchAccount is used. This
        // is needed of legacy pages as parts of the UI won't react to the
        // AuthState update.
        this.auth.authState$.pipe(pairwise()).subscribe(function (_a) {
            var previousAuth = _a[0], auth = _a[1];
            if (previousAuth && auth && previousAuth.userId !== auth.userId) {
                window.location.reload();
            }
        });
    };
    return CompatNavigationComponent;
}());
export { CompatNavigationComponent };
